import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import FolderIcon from '@mui/icons-material/Folder';
import ShieldIcon from '@mui/icons-material/Shield';
import HttpsIcon from '@mui/icons-material/Https';

export function Trust() {
  const { palette, typography } = useTheme();
  const { t } = useTranslation('landing');
  return (
    <Box
      id="trust"
      component="section"
      sx={{
        background: `linear-gradient(125deg, ${palette.primary.main} 60%, ${palette.secondary.main} 100%)`,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          pt: { xs: 4, sm: 8 },
          pb: { xs: 8, sm: 12 },
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Typography
            component="h2"
            sx={{
              textAlign: 'center',
              fontSize: {
                xs: typography.h4.fontSize,
                md: typography.h1.fontSize,
              },
              fontWeight: {
                xs: typography.h3.fontWeight,
                md: typography.h1.fontWeight,
              },
              color: palette.primary.contrastText,
            }}
          >
            {t('landing:trust.title')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: palette.background.default,
              py: { xs: 2, md: 3 },
              fontSize: {
                xs: typography.body2.fontSize,
                md: typography.h6.fontSize,
              },
            }}
          >
            {t('landing:trust.subTitle')}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Card
            variant="outlined"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderRadius: 3,
              gap: 1,
              maxWidth: { sx: 'none', md: 300 },
              p: 3,
            }}
          >
            <ShieldIcon sx={{ width: '48px', height: '48px' }} color="info" />
            <Typography
              variant="body1"
              gutterBottom
              sx={{ color: 'text.primary' }}
              fontWeight="600"
            >
              {t('landing:trust.options.private')}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
              {t('landing:trust.options.privateSub')}
            </Typography>
          </Card>
          <Card
            variant="outlined"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderRadius: 3,
              gap: 1,
              maxWidth: { sx: 'none', md: 300 },
              p: 3,
            }}
          >
            <HttpsIcon sx={{ width: '48px', height: '48px' }} color="info" />
            <Typography
              variant="body1"
              gutterBottom
              sx={{ color: 'text.primary' }}
              fontWeight="600"
            >
              {t('landing:trust.options.encryption')}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
              {t('landing:trust.options.encryptionSub')}
            </Typography>
          </Card>
          <Card
            variant="outlined"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              borderRadius: 3,
              gap: 1,
              maxWidth: { sx: 'none', md: 300 },
              p: 3,
            }}
          >
            <FolderIcon sx={{ width: '48px', height: '48px' }} color="info" />
            <Typography
              variant="body1"
              gutterBottom
              sx={{ color: 'text.primary' }}
              fontWeight="600"
            >
              {t('landing:trust.options.story')}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
              {t('landing:trust.options.storySub')}
            </Typography>
          </Card>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            py: 2,
            mt: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h3"
            component="h3"
            sx={{
              fontSize: {
                xs: typography.h4.fontSize,
                md: typography.h3.fontSize,
              },
              fontWeight: {
                xs: typography.h4.fontWeight,
                md: typography.h1.fontWeight,
              },
              color: palette.secondary.main,
            }}
          >
            Our Commitment to Your Privacy
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: {
                xs: typography.body1.fontSize,
                md: typography.h4.fontSize,
              },
              fontWeight: {
                xs: typography.body2.fontWeight,
                md: typography.body1.fontWeight,
              },
              color: palette.primary.contrastText,
            }}
          >
            We will never sell your data, show you ads based on your family
            information, or use your heritage for any purpose other than
            providing you with the safest home your family's history has ever
            had.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
